<template>
  <div v-if="show" class="modal-overlay" @mousedown.self="close">
    <dialog class="card modal-content">
      <h3 class="modal-title">Выберите шаблон</h3>

      <ul class="template-list">
        <li
          class="template-item"
          v-for="template in templates"
          :key="template.id"
          @click="select(template)"
        >
          <div class="item-info">
            <h4 class="item-name">{{ template.name }}</h4>
            <p class="item-desc" v-if="template.description">
              {{ template.description }}
            </p>
          </div>
        </li>
      </ul>

      <div class="modal-actions">
        <base-button @click="close">Отмена</base-button>
      </div>
    </dialog>
  </div>
</template>

<script>
export default {
  name: "OrderInvoiceTemplateSelectModal",
  props: {
    show: { type: Boolean, default: false },
    templates: { type: Array, default: () => [] },
  },
  emits: ["close", "select"],
  methods: {
    close() {
      this.$emit("close");
    },
    select(template) {
      this.$emit("select", template);
    },
  },
};
</script>

<style scoped>
.template-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: var(--base-in-indent);
}

.template-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  padding: 16px;
  background: rgb(240, 240, 240);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.template-item:hover {
  background: #e6f5ed;
  transform: translateX(4px);
}

.item-info {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.item-name {
  font-weight: 600;
}

.item-desc {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: #666;
}

.modal-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

@media (max-width: 768px) {
  .template-item {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
